import {remCalc} from '_themeUtils'

const inputCommons = {
    color: 'color.text.input.base',
    borderColor: 'color.border.input.primary',
    borderRadius: 'borderRadius.input.base',
    h: 'auto',
    px: 'spacing.3',
    py: 'spacing.3.5',
    mb: 'spacing.6',
    _placeholder: {
        color: 'color.text.input.placeholder',
    },
    _focusVisible: {
        borderColor: 'color.border.input.primary',
        boxShadow: 'none',
    },
    _focus: {
        outlineColor: '#262626',
    },
    _hover: {
        borderColor: 'color.border.input.primary',
        boxShadow: 'none',
    },
    _disabled: {
        borderColor: 'color.border.input.disabled',
        color: 'color.text.input.disabled',
    },
    '&[name="newsletter"]': {
        mb: 'spacing.4',
    },
}

const input = {
    Input: {
        baseStyle: {
            field: {
                ...inputCommons,
            },
            label: {
                textStyle: 'paragraphSm',
                fontWeight: 400,
                color: 'color.text.black',
                letterSpacing: remCalc(1),
                pl: 'spacing.3',
                pb: 'spacing.1',
                m: 0,
            },
        },
        variants: {
            search: {
                field: {
                    textStyle: {base: 'paragraphMd', lg: 'paragraphLg'},
                    letterSpacing: remCalc(0.9),
                    fontWeight: 300,
                    border: 'none',
                    borderBottom: '1px solid',
                    borderBottomColor: 'color.border.input.search',
                    pb: 'spacing.2',
                    _placeholder: {
                        textStyle: {base: 'paragraphMd', lg: 'paragraphLg'},
                        letterSpacing: remCalc(0.9),
                    },
                    _hover: {
                        borderColor: 'color.border.input.search',
                    },
                    _focusVisible: {
                        borderColor: 'color.border.input.search',
                    },
                },
            },
            newsletter: {
                field: {
                    border: '1px solid',
                    h: remCalc(54),
                    mb: 'spacing.5',
                    _invalid: {
                        borderColor: 'color.border.input.error',
                        boxShadow: 'none',
                        _hover: {
                            borderColor: 'color.border.input.error',
                            boxShadow: 'none',
                        },
                        _focusVisible: {
                            borderColor: 'color.border.input.error',
                            boxShadow: 'none',
                        },
                    },
                },
            },
        },
    },
    Textarea: {
        baseStyle: {
            ...inputCommons,
        },
    },
}

export default input
